import { render, staticRenderFns } from "./DeclareDetail.vue?vue&type=template&id=0c29fb3e&scoped=true&"
import script from "./DeclareDetail.vue?vue&type=script&lang=js&"
export * from "./DeclareDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeclareDetail.vue?vue&type=style&index=0&id=0c29fb3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29fb3e",
  null
  
)

export default component.exports